var _desc, _defs, _rect, _rect2, _rect3, _rect4, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCvvIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 20,
    viewBox: "0 0 32 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "\n\t\t\tCreated with Pixso.\n\t")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 598",
    x: 0.000244,
    rx: 3.222222,
    width: 31.999744,
    height: 20,
    fill: "#C4C4C4",
    fillOpacity: 1
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 599",
    y: 3.75,
    width: 31.999744,
    height: 3.75,
    fill: "#353535",
    fillOpacity: 1
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 603",
    x: 2.461426,
    y: 9.726562,
    rx: 1,
    width: 25.845949,
    height: 4.375,
    fill: "#FFFFFF",
    fillOpacity: 1
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 604",
    x: 18.711426,
    y: 9.976562,
    rx: 1,
    width: 9.346076,
    height: 3.875,
    stroke: "#EA1717",
    strokeOpacity: 1,
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M26.8 10.66L25.9 13.03L25.33 13.03L24.44 10.66L25.08 10.66L25.62 12.34L25.64 12.34L26.18 10.66L26.8 10.66Z",
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M24.54 10.66L23.64 13.03L23.07 13.03L22.18 10.66L22.82 10.66L23.36 12.34L23.38 12.34L23.92 10.66L24.54 10.66Z",
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M22.23 12.7C22.01 12.97 21.7 13.1 21.32 13.1C20.96 13.1 20.65 12.98 20.41 12.75C20.18 12.51 20.06 12.21 20.06 11.84C20.06 11.47 20.18 11.17 20.42 10.94C20.66 10.71 20.97 10.6 21.33 10.6C21.5 10.6 21.66 10.63 21.82 10.69C21.99 10.75 22.11 10.84 22.21 10.95L21.82 11.33C21.77 11.26 21.7 11.21 21.62 11.17C21.53 11.14 21.44 11.12 21.35 11.12C21.15 11.12 20.99 11.19 20.86 11.32C20.74 11.46 20.67 11.63 20.67 11.84C20.67 12.06 20.74 12.23 20.86 12.37C20.98 12.5 21.14 12.57 21.34 12.57C21.56 12.57 21.72 12.49 21.84 12.33L22.23 12.7Z",
    fill: "#353535",
    fillOpacity: 1,
    fillRule: "nonzero"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCvvIcon);
export default __webpack_public_path__ + "static/media/cvvIcon.babe7c55c8de2454ebee0b24f33c45e2.svg";
export { ForwardRef as ReactComponent };